module.exports = __webpack_public_path__ + "static/media/ThemeBG.ee705f4c.png";